import { IWebinar } from 'interfaces/webinars'
import { isMockWebinarsUiDevEnabled } from './isMockWebinarsUiDevEnabled'

/**
 * Desarrollo UI: antepone filas demo a la lista de webinars para probar la alerta
 * de sincronización Zoom sin integración real.
 *
 * Activar en `.env.local` (no commitear):
 *   REACT_APP_MOCK_WEBINARS=true
 *
 * Desactivar: quitar la variable o ponerla en false y reiniciar `npm start`.
 */
export function appendMockWebinarsUiDev(items: IWebinar[]): IWebinar[] {
  if (!isMockWebinarsUiDevEnabled()) {
    return items
  }

  const now = Date.now()
  const isoStartInTwoHours = new Date(now + 2 * 60 * 60 * 1000).toISOString()
  const isoStartInTenMinutes = new Date(now + 10 * 60 * 1000).toISOString()

  const mockSoonRow: IWebinar = {
    id: -9001,
    title: '[MOCK] Sin respuesta Zoom — verás Próximamente + alerta',
    course: 'Curso demo',
    courseId: 0,
    startTime: isoStartInTwoHours,
    timezone: 'America/Santiago',
    duration: 45,
    userCount: 3,
    hasIntegrationResponse: false,
  }

  const mockStartRow: IWebinar = {
    id: -9002,
    title: '[MOCK] Sin respuesta Zoom — verás Comenzar + alerta',
    course: 'Curso demo',
    courseId: 0,
    startTime: isoStartInTenMinutes,
    timezone: 'America/Santiago',
    duration: 30,
    userCount: 12,
    hasIntegrationResponse: true,
    hostUrl: 'https://zoom.us',
  }

  return [mockSoonRow, mockStartRow, ...items]
}
